__turbopack_context__.v({
  "SwiperTabs": "_5RzCQq_SwiperTabs",
  "active": "_5RzCQq_active",
  "activeContent": "_5RzCQq_activeContent",
  "autoWidthTabs": "_5RzCQq_autoWidthTabs",
  "content": "_5RzCQq_content",
  "fullWidth": "_5RzCQq_fullWidth",
  "shimmer": "_5RzCQq_shimmer",
  "tab": "_5RzCQq_tab",
  "tabContent": "_5RzCQq_tabContent",
  "tabs": "_5RzCQq_tabs",
  "text-bar-sweep": "_5RzCQq_text-bar-sweep",
});
